export enum NodeCategory {
  RESOURCE = 'RESOURCE',
  MODEL_CONCEPT_CLASS = 'MODEL_CONCEPT_CLASS',
}

export enum LinkLabelCategory {
  MAPPING_LABEL = 'MAPPING_LABEL',
  MODEL_CONCEPT_RELATIONSHIP_LABEL = 'MODEL_CONCEPT_RELATIONSHIP_LABEL',
  MODEL_CONCEPT_HIERARCHY_LABEL = 'MODEL_CONCEPT_HIERARCHY_LABEL',
}

export enum LinkCategory {
  MAPPING = 'MAPPING',
  MODEL_CONCEPT_RELATIONSHIP = 'MODEL_CONCEPT_RELATIONSHIP',
  MODEL_CONCEPT_HIERARCHY = 'MODEL_CONCEPT_HIERARCHY',
  RELATIONSHIP_MAPPING = 'RELATIONSHIP_MAPPING',
}

export enum HiddenCategory {
  NOT_HIDDEN = 'NOT_HIDDEN',
  MODEL_CONCEPT_ATTRIBUTE = 'MODEL_CONCEPT_ATTRIBUTE',
}
